<template>
    <div class="layout">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"><!-- 这里是会被缓存的视图组件，比如 Home！ --></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
        <!-- 返回上一页 -->
        <div class="back_wap" @click="goBack" v-if="show_back"><img :src="icon_back" alt="" class="icon_back" /></div>
        <!-- 底部通栏 -->
        <van-tabbar v-if="!isClient && show_tabber" v-model="active" @change="pageChange" style="height:1.31rem; box-shadow: 0 0 .3rem rgba(0, 0, 0, 0.05);z-index:10;">
            <van-tabbar-item name="home" class="home">
                <img slot="icon" :src="active == 'home' ? icons.active1 : icons.normal1" style="width: .56rem; height: .52rem;" />
                <span :style="{ fontSize: '0.27rem', color: active == 'home' ? '#b50001' : '#000' }">首页</span>
            </van-tabbar-item>
            <van-tabbar-item name="shop">
                <img
                    slot="icon"
                    :src="active == 'shop' ? icons.active2 : icons.normal2"
                    style="width:0.52rem;
                height:0.52rem; margin:.1rem auto 0 auto;"
                />
                <span :style="{ fontSize: '0.27rem', color: active == 'shop' ? '#b50001' : '#000' }">商城</span>
            </van-tabbar-item>
            <van-tabbar-item style="position: relative; top:-.27rem; z-index: 100;" name="map">
                <img slot="icon" :src="active == 'map' ? icons.activee : icons.normale" style="width: 1.11rem; height: 1.13rem; border:.04rem solid #fff; border-radius:50%;" />
                <span :style="{ fontSize: '0.27rem', color: active == 'map' ? '#b50001' : '#000' }">非遗地图</span>
            </van-tabbar-item>
            <van-tabbar-item name="message">
                <img slot="icon" :src="active == 'message' ? icons.active3 : icons.normal3" style="width:0.56rem; height:0.56rem; margin:.02rem auto 0 auto;" />
                <span :style="{ fontSize: '0.27rem', color: active == 'message' ? '#b50001' : '#000' }">消息</span>
            </van-tabbar-item>
            <van-tabbar-item name="my">
                <img slot="icon" :src="active == 'my' ? icons.active4 : icons.normal4" style="width:0.44rem; height:0.57rem; margin:.04rem auto 0 auto;" />
                <span :style="{ fontSize: '0.27rem', color: active == 'my' ? '#b50001' : '#000' }">我的</span>
            </van-tabbar-item>
        </van-tabbar>
        <van-overlay :show="loadingCount > 0">
            <div class="wrapper"><van-loading type="spinner" /></div>
        </van-overlay>
    </div>
</template>

<style scoped>
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>

<script>
import router from '../.././router';
import { LOGOUT, LOGIN } from '../.././vuex/mutation_types';
import Vue from 'vue';
import Bridge from '../.././vuex/bridge.js';
import WebIM from 'easemob-websdk';
import { Toast } from 'vant';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
    data() {
        return {
            isClient: false,
            isCollapsed: false, // 侧栏开关
            menuData: [], // 左侧菜单
            breadCrumbList: [], // 面包屑
            title: '首页', // 标题
            btns: [], // 功能按钮组
            active: 'home',
            publicPath: process.env.BASE_URL,
            icons: {
                normal1: process.env.BASE_URL + 'statics/images/nav_1.png',
                normal2: process.env.BASE_URL + 'statics/images/nav_2.png',
                normal3: process.env.BASE_URL + 'statics/images/nav_3.png',
                normal4: process.env.BASE_URL + 'statics/images/nav_4.png',
                normale: process.env.BASE_URL + 'statics/images/nav_e.png',
                active1: process.env.BASE_URL + 'statics/images/nav_1_active.png',
                active2: process.env.BASE_URL + 'statics/images/nav_2_active.png',
                active3: process.env.BASE_URL + 'statics/images/nav_3_active.png',
                active4: process.env.BASE_URL + 'statics/images/nav_4_active.png',
                activee: process.env.BASE_URL + 'statics/images/nav_e.png'
            },
            show_tabber: true, // 是否显示底部栏
            icon_back: process.env.BASE_URL + 'statics/images/icon_back.png',
            show_back: false, // 是否显示返回图标
            loadingCount: 0, //当前显示loading的个数
            share_config: false, // 分享配置标识
            shareConfig: null, // 分享的相关配置
            webimfriends: [], // 环信好友列表
            getTextMsg: null, // 接收环信信息；
        };
    },
    beforeMount() {
        this.createHX();
    },
	mounted(){
		
	},
    // 返回上一页
    goBack() {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.$bridge.callhandler("sdjy://public/back", {},
                (data) => {
                    if (data.code == 200) {
                        // this.token = data.result.token;
                        // this.openSpeak()
                    } else {
                        // this.token = "";
                    }
                }
            );
        } else {
            if (window.history.length <= 1) {
                console.log('this.$route', this.$route.fullPath);
                if (this.$route.fullPath.indexOf('/tohistory/detail') > -1) {
                    this.$router.push({
                        path: '/tohistory/index'
                    });
                } else {
                    this.$router.push({ path: '/' });
                }
                // this.$router.push({path:'/'})
                return false;
            } else {
                this.$router.back(-1);
            }
        }
        
    },
    computed: {},
    created: function() {
        // console.log('this.$route', this.$route)
        // console.log(location.href)
        // console.log(this.$route)
        if (this.$route.name != this.active) {
            // console.log('111111',this.$route.name,this.active)
            this.active = this.$route.name;
        }
        // console.log('222222', this.$route.name, this.active)
        // console.log(userAgent)
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏tabbar
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            console.log(true);
            this.isClient = true;
        }
        // 根据路由判断，一级页面显示底部导航,
        console.log('this.$route.name:',this.$route.name)
        if ((this.$route.name.indexOf('-') != -1 && this.$route.name != 'map-quanguo') || this.$route.name == 'search' || this.$route.name == 'searchNew' || this.$route.name == 'search-item') {
            this.show_tabber = false;
        } else {
            this.show_tabber = true;
        }
        // 根据路由判断, meta.icon_back 为true显示返回按钮
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            
            if (this.$route.meta.app_icon_back == true) {
                this.show_back = true;
            } else {
                this.show_back = false;
            }
        } else {
            if (this.$route.meta.icon_back) {
                this.show_back = true;
            } else {
                this.show_back = false;
            }
            // 根据路由判断, meta.share_config 为true, 统一设置分享
            if (this.$route.meta.share_config) {
                this.getShareData();
            }
            console.log('this.share_config', this.share_config);
        }

        // // 登录环信
        // if (this.$store.getters.token != null) {
        //     this.getWebIMInfo();
        // }
    },
    methods: {
        createHX() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            let that = this;
            console.log('WebIM~~~~~~~~~~~~~~', WebIM);
            WebIM.config = that.$publicData.webimConfig;
            that.$publicData.webimconn = WebIM.conn = new WebIM.connection({
                appKey: WebIM.config.appkey,
                isHttpDNS: WebIM.config.isHttpDNS,
                isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
                https: WebIM.config.https,
                url: WebIM.config.xmppURL,
                apiUrl: WebIM.config.apiURL,
                isAutoLogin: WebIM.config.isAutoLogin,
                heartBeatWait: WebIM.config.heartBeatWait,
                autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
                autoReconnectInterval: WebIM.config.autoReconnectInterval,
                isStropheLog: WebIM.config.isStropheLog,
                delivery: WebIM.config.delivery
            });

            // 环信监听
            that.webIMListen();

            // console.log('that.$publicData.webimconn:',that.$publicData.webimconn);

            that.getWebIMInfo();
        },
        pageChange(event) {
            // console.log('event', event);
            if (event == 'home') {
                this.$router.push('/');
            } else {
                this.$router.push(`/${event}/index`);
            }
            this.active = event;
        },
        // 返回上一页
        goBack() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                this.$bridge.callhandler("sdjy://public/back", {},
                    (data) => {
                        if (data.code == 200) {
                            // this.token = data.result.token;
                            // this.openSpeak()
                        } else {
                            // this.token = "";
                        }
                    }
                );
            } else {
                if (this.$route.fullPath.indexOf('/tohistory/detail') > -1) {
                    this.$router.push({
                        path: '/tohistory/index'
                    });
                } else {
                    if (window.history.length <= 1) {
                        console.log('this.$route', this.$route.fullPath);
                        this.$router.push({ path: '/' });
                        // this.$router.push({path:'/'})
                        return false;
                    } else {
                        this.$router.back(-1);
                    }
                }
            }
            
        },
        showLoading() {
            this.loadingCount = this.loadingCount + 1;
            console.log(this.loadingCount);
        },
        hiddenLoading() {
            this.loadingCount = this.loadingCount - 1;
            if (this.loadingCount < 0) {
                this.loadingCount = 0;
            }
        },
        hiddenAllLoading() {
            this.loadingCount = 0;
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url);
            this.$api.index
                .commonShare({
                    url: url
                })
                .then(res => {
                    if (res.code == 200) {
                        this.shareConfig = res.result;
                        this.shareFun();
                    }
                });
        },
        // 分享
        shareFun() {
            var that = this;
            console.log('that.$route.meta', that.$route.meta);
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
				openTagList: that.shareConfig.openTagList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function() {
                const url = location.href.split('#')[0];
                var shareDataA = {
                    title: that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.$publicData.shareDefaultTitleB, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function(e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                };
                var shareDataB = {
                    title: that.$publicData.shareDefaultTitleB, // 分享标题
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function(e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                };

                wx.updateAppMessageShareData(shareDataA); // 分享给朋友
                wx.updateTimelineShareData(shareDataB); // 分享到朋友圈
            });
        },
        // 环信 监听
        webIMListen() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            let that = this;
            that.$publicData.webimconn.listen({
                onOpened: function(message) {
                    // 连接成功回调
                    console.log('连接成功回调(onOpened):', message);
                    // 查询好友列表
                    // that.getRoster();
                },
                onClosed: function(message) {
                    // 连接关闭回调
                    console.log('连接关闭回调(onClosed):', message);
                },
                onTextMessage: function(message) {
                    // 收到文本消息
                    console.log('收到文本消息(onTextMessage):', message);
                    that.getTextMsg = message;
                },
                onEmojiMessage: function(message) {
                    // 收到表情消息
                    console.log('收到表情消息(onEmojiMessage):', message);
                },
                onPictureMessage: function(message) {
                    // 收到图片消息
                    console.log('收到图片消息(onPictureMessage):', message.url);
                },
                onCmdMessage: function(message) {
                    // 收到命令消息
                    console.log('收到命令消息(onCmdMessage):', message);
                },
                onAudioMessage: function(message) {
                    // 收到音频消息
                    console.log('收到音频消息(onAudioMessage):', message);
                },
                onLocationMessage: function(message) {
                    // 收到位置消息
                    console.log('收到位置消息(onLocationMessage):', message);
                },
                onFileMessage: function(message) {
                    // 收到文件消息
                    console.log('收到文件消息(onFileMessage):', message);
                },
                onVideoMessage: function(message) {
                    // 收到视频消息
                    console.log('收到视频消息(onVideoMessage):', message);
                    var node = document.getElementById('privateVideo');
                    var option = {
                        url: message.url,
                        headers: {
                            Accept: 'audio/mp4'
                        },
                        onFileDownloadComplete: function(response) {
                            var objectURL = WebIM.utils.parseDownloadResponse.call(conn, response);
                            node.src = objectURL;
                        },
                        onFileDownloadError: function() {
                            console.log('File down load error.');
                        }
                    };
                    WebIM.utils.download.call(conn, option);
                },
                onPresence: function(message) {
                    //处理“广播”或“发布-订阅”消息，如联系人订阅请求、处理群组、聊天室被踢解散等消息
                    console.log('处理“广播”或“发布-订阅”消息，如联系人订阅请求、处理群组、聊天室被踢解散等消息(onPresence):', message);
                    //对方收到请求加为好友
                    if (message.type === 'subscribe') {
                        /*同意添加好友操作的实现方法*/
                        // that.$publicData.webimconn.subscribed({
                        //     to: message.from,
                        //     message: '[resp:true]'
                        // });
                    }
                    // that.$dialog.confirm({
                    //     title:'好友申请',
                    //     message: message.status,
                    //     confirmButtonText: '同意',
                    //     cancelButtonText: '拒绝'
                    // });
                },
                onRoster: function(message) {
                    // 处理好友申请
                    console.log('处理好友申请(  ):', message);
                    // that.$publicData.webimconn.subscribed({
                    //     to: 'username',
                    //     message : '[resp:true]'
                    // });
                },
                onInviteMessage: function(message) {
                    // 处理群组邀请
                    console.log('处理群组邀请(onInviteMessage):', message);
                },
                onOnline: function() {
                    // 本机网络连接成功
                    console.log('本机网络连接成功(onOnline)');
                },
                onOffline: function() {
                    // 本机网络掉线
                    console.err('本机网络掉线(onOffline)');
                },
                onError: function(message) {
                    // 失败回调
                    console.error('失败回调(onError):', message);
                    // that.onLoad();
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    } else {
                        if (that.$publicData.connectTime > 3) {
                            if (message.type == 206 || message.type == 28) {
                                that.$publicData.isIMLogout = true
                            }
                        } else {
                            setTimeout(function() {
                                that.getWebIMInfo();
                                that.$publicData.connectTime++
                            }, 2000);
                        }
                    }
                },
                onBlacklistUpdate: function(list) {
                    // 黑名单变动
                    // 查询黑名单，将好友拉黑，将好友从黑名单移除都会回调这个函数，list则是黑名单现有的所有好友信息
                    console.log('黑名单变动 - 查询黑名单，将好友拉黑，将好友从黑名单移除都会回调这个函数，list则是黑名单现有的所有好友信息(onBlacklistUpdate):', list);
                },
                onRecallMessage: function(message) {
                    // 收到撤回消息回调
                    console.log('收到撤回消息回调(onRecallMessage):', message);
                },
                onReceivedMessage: function(message) {
                    // 收到消息送达服务器回执
                    console.info('收到消息送达服务器回执(onReceivedMessage):', message);
                },
                onDeliveredMessage: function(message) {
                    // 收到消息送达客户端回执
                    console.info('收到消息送达客户端回执(onDeliveredMessage):', message);
                },
                onReadMessage: function(message) {
                    // 收到消息已读回执
                    console.log('收到消息已读回执(onReadMessage):', message);
                },
                onCreateGroup: function(message) {
                    // 创建群组成功回执（需调用createGroupNew）
                    console.log('创建群组成功回执（需调用createGroupNew）(onCreateGroup):', message);
                },
                onMutedMessage: function(message) {
                    // 如果用户在A群组被禁言，在A群发消息会走这个回调并且消息不会传递给群其它成员
                    console.log('如果用户在A群组被禁言，在A群发消息会走这个回调并且消息不会传递给群其它成员(onMutedMessage):', message);
                }
            });
        },
        // 获取环信用户信息
        getWebIMInfo() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                return;
            } else {
                var token = this.$store.getters.token;
                var uuid = this.$store.getters.uuid;
                const userInfo = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'));
                this.getWebIMInfoDetail(userInfo, token, uuid);
            }
        },
        getWebIMInfoDetail(userInfo, token, uuid) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            var that = this;
            // 有记录用户信息
            if (userInfo && userInfo != undefined) {
                const userName = userInfo.userId;
                const password = userInfo.password;
                var options = {
                    apiUrl: WebIM.config.apiURL,
                    user: userName,
                    pwd: password,
                    appKey: WebIM.config.appkey
                };
                that.$publicData.webimconn.open(options);
                // 环信监听
                that.webIMListen();
            } else {
                // 没有记录用户信息
                // 登录环信
                if (token != null && token != undefined && token != '') {
                    var params = {
                        token: token,
                        uuid: uuid
                    };
                    this.$api.xiaoxi.userInfo(params).then(res => {
                        if (res.code == 200) {
                            this.$publicData.webimUserInfo = res.result;
                            console.log('记录全局webimUserInfo', this.$publicData.webimUserInfo);
                            // 登录环信
                            var options = {
                                apiUrl: that.$publicData.webimConfig.apiURL,
                                user: that.$publicData.webimUserInfo.im_username,
                                pwd: that.$publicData.webimUserInfo.im_pwd,
                                appKey: that.$publicData.webimConfig.appkey,
                                success: function(res) {
                                    console.log('res~~~~~~~~~~~~~~~~~~~~~~~~~~', res);
                                    token = res.access_token;
                                    var options1 = {
                                        apiUrl: that.$publicData.webimConfig.apiURL,
                                        user: res.username,
                                        accessToken: res.access_token,
                                        appKey: that.$publicData.webimConfig.appkey
                                    };
                                    that.$publicData.webimconn.open(options1);
                                    localStorage.setItem(
                                        'userInfo',
                                        JSON.stringify({ userId: that.$publicData.webimUserInfo.im_username, password: that.$publicData.webimUserInfo.im_pwd, token: token })
                                    );

                                    // 环信监听
                                    that.webIMListen();
                                },
                                error: function() {}
                            };
                            that.$publicData.webimconn.open(options);
                            // localStorage.setItem("userInfo", JSON.stringify({ userId: that.$publicData.webimUserInfo.im_username, password: that.$publicData.webimUserInfo.im_pwd, token: token }));
                        }
                    });
                }
            }
        },

        // 环信发消息 （跟匠人沟通）
        sendMsgToTradesman(txt, sender, getters, callback) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            if (callback == undefined) {
                callback = function() {};
            }
            console.log('getters::', getters);
            // return;
            // let hasFriend = false;  // 是否是好友 false 不是，true 是；
            // for(var i in this.webimfriends) {
            //     if ( this.webimfriends[i].name == getters.im_username ) {
            //         hasFriend = true;
            //     }
            // }
            // // 不是好友先加好友
            // if ( !hasFriend ) {
            //     console.error('不是好友',getters)
            //     this.addRoster({name:getters.username, username:getters.im_username});
            // }
            // 单聊发送文本消息
            console.log('MessageTxt:', txt);
            let that = this;
            var sendPrivateText = function() {
                var id = that.$publicData.webimconn.getUniqueId(); // 生成本地消息id
                var msg = new WebIM.message('txt', id); // 创建文本消息
                msg.set({
                    msg: txt, // 消息内容
                    from: sender,
                    to: getters, // 接收消息对象（用户id）
                    roomType: false,
                    ext: {
                        // key2: {
                        //     key3: value2
                        // }
                    }, //扩展消息
                    success: function(id, serverMsgId) {
                        console.log('send private text Success', id, serverMsgId); // 对成功的相关定义，sdk会将消息id登记到日志进行备份处理

                        console.log('发送环信查看回调：', callback);
                        callback();
                    },
                    fail: function(e) {
                        console.log('Send private text error', e); // 对失败的相关定义，sdk会将消息id登记到日志进行备份处理
                        callback();
                    }
                });
                console.log(msg);
                that.$publicData.webimconn.send(msg.body);
            };

            sendPrivateText();
        },
        // 环信发图片 （跟匠人沟通）
        sendImageToTradesman(imageUrl, sender, getters, callback) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            if (callback == undefined) {
                callback = function() {};
            }
            console.log('getters::', getters);
            let that = this;
            var url = that.$publicData.domain + imageUrl; // that.$publicData.domain +
            console.log('url:', url);

            // web单聊发送图片消息
            // var sendPrivateImg = function() {
            var id = that.$publicData.webimconn.getUniqueId(); // 生成本地消息id
            var msg = new WebIM.message('img', id); // 创建图片消息
            console.log('msg:', msg);
            var option = {
                body: {
                    type: 'file',
                    url: url,
                    size: {
                        width: 100,
                        height: 100
                    },
                    length: 1,
                    filename: 'chat',
                    filetype: 'png'
                },
                to: getters, // 接收消息对象
                success: function(id, serverMsgId) {
                    console.log('send private text Success', id, serverMsgId); // 对成功的相关定义，sdk会将消息id登记到日志进行备份处理

                    console.log('发送环信查看回调：', callback);
                    callback();
                },
                fail: function(e) {
                    console.log('Send private text error', e); // 对失败的相关定义，sdk会将消息id登记到日志进行备份处理
                    callback();
                }
            };
            msg.set(option);
            that.$publicData.webimconn.send(msg.body);
            // };
            // sendPrivateImg();
        },
        // 获取历史消息
        getHistoryMessage: function(obj, callback) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            if (callback == undefined) {
                callback = function(msgs) {
                    console.log('默认：历史消息回调:', msgs);
                };
            }

            console.log('获取历史消息：', obj);
            if (obj.count == undefined) {
                obj.count == 10;
            }

            let that = this;
            /**
             * 获取对话历史消息
             * @param {Object} options
             * @param {String} options.queue   - 对方用户id（如果用户id内含有大写字母请改成小写字母）/群组id/聊天室id
             * @param {String} options.count   - 每次拉取条数,不刷新页面情况下，每请发一次请求回拉去当前获取历史最早记录的前一段记录
             * @param {Boolean} options.isGroup - 是否是群聊，默认为false
             * @param {Function} options.success
             * @param {Funciton} options.fail
             */
            var options = {
                queue: obj.name.toLowerCase(),
                isGroup: obj.isGroup,
                count: obj.count, // 每次获取消息条数
                success: function(msgs) {
                    console.log('获取历史消息查看数据：', msgs);
                    try {
                        obj.success && obj.success(msgs);
                        if (msgs.length) {
                            console.log('获取历史消息成功：', msgs);
                            // const userInfo = JSON.parse(localStorage.getItem("userInfo"));
                            // const userId = userInfo && userInfo.userId;
                            // msgs.forEach((item) => {
                            //     let time = Number(item.time);
                            //     let dates = new Date(time);
                            //     var t = dates.getFullYear() + '年' + dates.getMonth() + 1 + '月' + dates.getDate() + '日' + dates.getHours() + ":" + dates.getMinutes() + ':' + dates.getSeconds();
                            //     // console.log(t)
                            //     let msg = {};
                            //     const bySelf = item.from == userId;
                            //     if (!item.filename) {
                            //         msg = {
                            //             chatType: obj.isGroup ? "group" : "contact",
                            //             chatId: bySelf ? item.to : item.from,
                            //             msg: item.data,
                            //             bySelf: bySelf,
                            //             time: time,
                            //             mid: item.id,
                            //             status: "read"
                            //         };
                            //         if (obj.isGroup) {
                            //             msg.chatId = item.to;
                            //         }
                            //         else {
                            //             msg.chatId = bySelf ? item.to : item.from;
                            //         }
                            //     }
                            //     else if (!item.ext.file_length && item.filename !== "audio" && item.filename.substring(item.filename.length - 3) !== "mp4") { // 为图片的情况
                            //         msg = {
                            //             msg: item.url,
                            //             chatType: obj.isGroup ? "group" : "contact",
                            //             chatId: bySelf ? item.to : item.from,
                            //             bySelf: bySelf,
                            //             type: "img",
                            //             time: time,
                            //             mid: item.id,
                            //             status: "read"
                            //         };
                            //         if (obj.isGroup) {
                            //             msg.chatId = item.to;
                            //         }
                            //         else {
                            //             msg.chatId = bySelf ? item.to : item.from;
                            //         }
                            //     }
                            //     else if (item.filename === "audio") {
                            //         msg = {
                            //             msg: item.url,
                            //             chatType: obj.isGroup ? "group" : "contact",
                            //             chatId: bySelf ? item.to : item.from,
                            //             bySelf: bySelf,
                            //             type: "audio"
                            //         };
                            //         if (obj.isGroup) {
                            //             msg.chatId = item.to;
                            //         }
                            //         else {
                            //             msg.chatId = bySelf ? item.to : item.from;
                            //         }
                            //     }
                            //     else if (item.filename.substring(item.filename.length - 3) === "mp4") {
                            //         msg = {
                            //             msg: item.url,
                            //             chatType: obj.isGroup ? "group" : "contact",
                            //             chatId: bySelf ? item.to : item.from,
                            //             bySelf: bySelf,
                            //             type: "video"
                            //         };
                            //         if (obj.isGroup) {
                            //             msg.chatId = item.to;
                            //         }
                            //         else {
                            //             msg.chatId = bySelf ? item.to : item.from;
                            //         }
                            //     }
                            //     else {
                            //         msg = {
                            //             msg: item.url,
                            //             chatType: obj.isGroup ? "group" : "contact",
                            //             chatId: bySelf ? item.to : item.from,
                            //             bySelf: bySelf,
                            //             type: "file",
                            //             filename: item.filename,
                            //             file_length: item.file_length,
                            //             time: time,
                            //             mid: item.id,
                            //             status: "read"
                            //         };
                            //         if (obj.isGroup) {
                            //             msg.chatId = item.to;
                            //         }
                            //         else {
                            //             msg.chatId = bySelf ? item.to : item.from;
                            //         }
                            //     }
                            //     msg.isHistory = true;
                            // });
                            callback(msgs);
                        } else {
                            callback(msgs);
                        }
                    } catch (e) {
                        console.log('error', e);
                        callback([{ time: 0, data: '' }]);
                    }
                },
                fail: function(ee) {
                    console.error('拉取历史信息失败ee：', ee);
                    callback([{ time: 0, data: '' }]);
                }
            };
            that.$publicData.webimconn.fetchHistoryMessages(options);
        },
        // 环信 - 查询好友列表
        getRoster() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            let that = this;
            that.$publicData.webimconn.getRoster({
                success: function(roster) {
                    console.log('roster', roster);
                    //获取好友列表，并进行好友列表渲染，roster格式为：
                    /** [
                              {
                                jid:'asemoemo#chatdemoui_test1@easemob.com',
                                name:'test1',
                                subscription: 'both'
                              }
                            ]
                        */
                    let friends = [];
                    for (var i = 0, l = roster.length; i < l; i++) {
                        var ros = roster[i];
                        if (ros.subscription === 'both' || ros.subscription === 'to') {
                            friends.push(ros);
                        }
                    }
                    // 好友列表
                    this.webimfriends = friends;
                }
            });
        },
        // 环信 - 添加好友
        addRoster(obj) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            console.log('addRoster,', obj.username);
            // 添加好友
            this.$publicData.webimconn.subscribe({
                to: obj.username,
                message: obj.name + '请求加您为好友!'
            });
        },
        // 环信 - 退出登录
        msgLogOut() {
            this.$publicData.webimconn.close();
            localStorage.removeItem('userInfo');
            localStorage.removeItem('user_name');
            localStorage.removeItem('thumb');
        },
        // 环信 - 重新登录
        reloadHX() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            this.$publicData.webimconn.close();
            localStorage.removeItem('userInfo');
            localStorage.removeItem('user_name');
            localStorage.removeItem('thumb');
            this.createHX();
        },
        // 更新最后发送或接受信息的时间 用于对比信息列表是否有未读消息
        updateHistoryList(obj) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                if (this.$route.fullPath.indexOf('/message/index') > -1) {
                    return;
                }
                //客户端只有消息页面手动开启
            }
            if (obj.to_user == undefined) {
                console.error('更新最后发送/接收历史列表失败，原因是：to_user不能为空');
                return;
            }

            if (obj.time == undefined) {
                console.error('更新最后发送/接收历史列表失败，原因是：time不能为空');
                return;
            }

            var msghistorylist = localStorage.getItem('msghistorylist');
            if (!msghistorylist) {
                msghistorylist = [];
            } else {
                msghistorylist = JSON.parse(msghistorylist);
            }
            var hasUser = false;
            for (var i = 0; i < msghistorylist.length; i++) {
                if (msghistorylist[i].to_user == obj.to_user) {
                    hasUser = true;
                    if (msghistorylist[i].time < obj.time) {
                        msghistorylist[i].time = obj.time;
                    }
                }
            }
            if (!hasUser) {
                msghistorylist.push(obj);
            }
            msghistorylist = JSON.stringify(msghistorylist);
            localStorage.setItem('msghistorylist', msghistorylist);
        },
    },
    watch: {
        $route(to, from) {
            // console.log('route', to.name);
            console.log('route-----', this.$route);
            this.active = to.name;
            // 根据路由判断，非一级页面不显示底部导航
            console.log('this.$route.name:',this.$route.name)
            if ((to.name.indexOf('-') != -1 && this.$route.name != 'map-quanguo') || this.$route.name == 'search' || this.$route.name == 'searchNew' || this.$route.name == 'search-item') {
                this.show_tabber = false;
            } else {
                this.show_tabber = true;
            }
            // 根据路由判断, meta.icon_back 为true显示返回按钮
            if (this.$route.meta.icon_back) {
                this.show_back = true;
            } else {
                this.show_back = false;
            }
            // 根据路由判断, meta.share_config 为true, 统一设置分享
            if (this.$route.meta.share_config) {
                this.getShareData();
            }

            // if ( to.name == 'message' ) {
            //     this.reloadHX();
            // }
        }
    },
	destroyed(){
		
	}

};
</script>
<style scoped>
	.van-tabbar-item--active{
		background-color: transparent !important;
	}
</style>
